import { ChangeEvent } from 'react'
import { MenuItem, TextField, TextFieldProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface InputCablesSelectProps extends Omit<TextFieldProps, 'value' | 'onChange'> {
  value?: number
  allowEmpty?: boolean
  onChange: (inputCables: number | undefined) => void
}

/**
 * Select for the number of input cables.
 */
export default function InputCablesSelect({
  value,
  allowEmpty = false,
  onChange,
  ...props
}: InputCablesSelectProps) {
  const [t] = useTranslation('common')

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    onChange(event.target.value === '' ? undefined : Number(event.target.value))
  }

  return (
    <TextField
      name="inputCables"
      label={t('inputCables')}
      select
      value={value ?? ''}
      onChange={handleChange}
      {...props}
    >
      {allowEmpty && (
        <MenuItem value="">
          <em>{t('notSelected')}</em>
        </MenuItem>
      )}
      <MenuItem value={0}>0</MenuItem>
      <MenuItem value={1}>1</MenuItem>
      <MenuItem value={2}>2</MenuItem>
      <MenuItem value={3}>3</MenuItem>
      <MenuItem value={4}>4</MenuItem>
      <MenuItem value={5}>5</MenuItem>
    </TextField>
  )
}
